import React, { useState, useEffect, useRef } from 'react'
import './PopupWindowBuildingDetail.css'
import httpClient from '../helpers/httpClient'
import { toast } from "react-toastify"
import GeneralSection from './components/GeneralSection'
import PriceSection from './components/PriceSection'
import Button from '../UI/Button'

function PopupWindowBuildingDetail({
  isActive, setIsActive, onClose, actionType, selectedItem, setSelectedItem, projectID, selectedItemID, fetchProject, contactsList
}) {
  const initialBuildingState = {
    building_name: '',
    architect: '',
    safety_coordinator: '',
    reduced_vat_rate_eligible: false,
    permits: '',
    assurances: '',
    co_ownership: false,
    shares_co_ownership: '',
    // Construction period
    construction_start_date: null,
    construction_end_date: null,
    // Insurance fields
    insurance: '',
    insurance_broker_id: null,
    insurance_company_id: null,
    insurance_start_date: null,
    insurance_end_date: null,
    insurance_guarantee_start_date: null,
    insurance_guarantee_end_date: null,
    // Notes
    notes: ''
  }

  const [building, setBuilding] = useState(initialBuildingState)
  const [menuItem, setMenuItem] = useState("general")
  const [loading, setLoading] = useState({
    general: true,
    prices: false
  })
  const [creatingNote, setCreatingNote] = useState(false)

  const generalSectionRef = useRef()
  const priceSectionRef = useRef(null)

  useEffect(() => {
    const popup = document.getElementById('popup-building-detail')
    window.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        if (popup.classList.contains("active")) {
          closePopupWindow()
        }
      }
    })
  }, [])

  useEffect(() => {
    setBuilding({ ...initialBuildingState, ...selectedItem })
  }, [isActive, selectedItem])

  const closePopupWindow = () => {
    setIsActive(false)
    setBuilding(initialBuildingState)
    setMenuItem("general")
    setCreatingNote(false)
  }

  const handleSave = async () => {
    if (creatingNote) {
      const success = await generalSectionRef.current.handleCreateNote()
      return
    }

    if (!building.building_name) {
      toast.error("Name is obligatory")
      return
    }

    const saveBuilding = httpClient.post(
      import.meta.env.VITE_API_URL + `/api/buildings/create?projectID=${projectID}&itemID=${selectedItemID}&actionType=${actionType}`,
      building
    )

    await toast.promise(
      saveBuilding,
      {
        success: `Building has been ${actionType == "add" ? "created" : "updated"}!`,
        error: "Something went wrong",
        pending: `${actionType == "add" ? "creating" : "updating"} building...`
      }
    )

    // cleanup state
    const prevStateBuilding = { ...building }
    Object.keys(prevStateBuilding).forEach(key => {
      prevStateBuilding[key] = ''
    })
    setBuilding(prevStateBuilding)

    setIsActive(false)
    fetchProject()
  }

  const handleSetMenuItem = (menuItem) => {
    setMenuItem(menuItem)
    setCreatingNote(false)
  }

  return (
    <div
      className={`popup__container building-detail overlay no-scrollbar ${isActive ? "active" : ""}`}
      id='popup-building-detail'
      onClick={closePopupWindow}
      onKeyDown={e => e.key === "Escape" && closePopupWindow()}
    >
      <div className='popup__box no-scrollbar' onClick={e => e.stopPropagation()}>
        <div className='close_button' onClick={closePopupWindow}>x</div>
        <div className='popout_body' id='popout-body-building'>
          
          <div className='popout_window__header'>
            {menuItem === 'general' && <Button variant='primary' size='sm' onClick={handleSave}>
              {creatingNote ? "CREATE NOTE" : "SAVE"}
            </Button>}
            <div className='popout_window__header--title'>
              {actionType == "add" ? "add building" : `Building | ${building?.building_name ? building.building_name : ""}`}
            </div>
          </div>

          <div className='menu__titles'>
            <h3 className={`${menuItem == "general" ? "selected" : ""}`} onClick={() => setMenuItem("general")}>general</h3>
            {actionType != "add" && (
              <h3 className={`${menuItem == "prices" ? "selected" : ""}`} onClick={() => handleSetMenuItem("prices")}>instalments</h3>
            )}
          </div>

          {menuItem == "general" && (
            <GeneralSection
              ref={generalSectionRef}
              building={building}
              setBuilding={setBuilding}
              actionType={actionType}
              contactsList={contactsList}
              creatingNote={creatingNote}
              setCreatingNote={setCreatingNote}
            />
          )}

          {menuItem == "prices" && (
            <PriceSection
              ref={priceSectionRef}
              building={building}
              loading={loading}
            />
          )}

        </div>
      </div>
    </div>
  )
}

export default PopupWindowBuildingDetail
